import React, {useEffect} from "react";
import {useState} from "react";
import {getSteps} from "../../../../data/booking/api/api";
import ComboBox from "../../../shared/components/form/ComboBox";
import cx from "classnames"
import { withTranslation } from "react-i18next";
import isEmpty from "lodash/isEmpty";

const Option = ({ item, showDistance, selected, active }) =>{
    return <div className="group flex cursor-pointer flex-col">
        <div
            className={cx("block", {
                "font-semibold": selected,
            })}
        >
            {item.title}
            {(showDistance && item.distance > 0) && <span> ({item.distance}km)</span>}
            {item.out &&<small><em> - hors GR</em></small>}
        </div>
        {!isEmpty(item.localities) && <div className={cx("truncate text-sm italic", {
            "text-gray-600": !active,
            "text-gray-200": active,
            "font-semibold": selected
        })}>{item.localities.map(locality => locality.title).join(', ')}</div>}
    </div>
};

function StepFinder({showDistance, fromStepId = null, direction = 1, onChange, isClearable, isDisabled, value, hikeId, t, ...props}) {
    const [options, setOptions] = useState(null);

    const handleSelect = (value) => {
        onChange(value);
    }

    useEffect(() => {
        setOptions(null)
        getSteps(hikeId, fromStepId, direction)
            .then(result => result.json())
            .then(json => json.map(option=> ({
                ...option,
                value: option.id,
                label: option.title})))
            .then(selectOptions => setOptions(selectOptions))
    }, [hikeId, fromStepId, direction]);

    return (
        <ComboBox
            searchFields={['title', 'localities.title']}
            clearable={isClearable}
            onChange={handleSelect}
            options={options == null ? [] : options}
            components={{ Option: ({item, ...props}) => <Option item={item} {...props} showDistance={showDistance} /> }}
            isLoading={options == null}
            isDisabled={options == null || isDisabled}
            showDistance={showDistance}
            noOptionsMessage={() =>"Pas de résultats"}
            loadingMessage={t('shared.search') + "..."}
            {...props}
            value={value ? {
                ...value,
                label: value.title,
                value: value.id
            } : null}
        />
    );
}

export default withTranslation()(StepFinder);